import React, {useEffect, useState} from "react";
import CardsWrap from "./cards_wrap";
import Parser from "html-react-parser";

import { HttpClient } from "actions/HttpClient";
import { CPlanesService } from "actions/HttpCalls";

const httpClient = new HttpClient();
const cPlanesService = new CPlanesService(httpClient);

// const urlBoton = localStorage.getItem('urlBoton') ? localStorage.getItem('urlBoton') : '';
// const targetBoton = localStorage.getItem('targetBoton') ? localStorage.getItem('targetBoton') : '';
const tituloRecomendacion = localStorage.getItem("tituloRecomendacion")
  ? localStorage.getItem("tituloRecomendacion")
  : "";
const descRecomendacion = localStorage.getItem("descRecomendacion")
  ? localStorage.getItem("descRecomendacion")
  : "";
const txtCondiciones = localStorage.getItem("txtCondiciones")
  ? localStorage.getItem("txtCondiciones")
  : "";
const urlBotonCotizar = localStorage.getItem("urlBotonCotizar")
  ? localStorage.getItem("urlBotonCotizar")
  : "";
const txtBotonCotizar = localStorage.getItem("txtBotonCotizar")
  ? localStorage.getItem("txtBotonCotizar")
  : "";
const targetBotonCotizar = localStorage.getItem("targetBotonCotizar")
  ? localStorage.getItem("targetBotonCotizar")
  : "";
const tituloSolicitarPlan = localStorage.getItem("tituloSolicitarPlan")
  ? localStorage.getItem("tituloSolicitarPlan")
  : "";
const descSolicitarPlan = localStorage.getItem("descSolicitarPlan")
  ? localStorage.getItem("descSolicitarPlan")
  : "";
const redirectThanks = localStorage.getItem("version_comparador") === "v2" ? true : false;

function BannerCallBack(urlBotonCotizar) {
  console.log("urlBotonCotizar", urlBotonCotizar);
  localStorage.removeItem("AmountPonderacion");
  localStorage.removeItem("cotUsername");
  localStorage.removeItem("cotUsermail");
  localStorage.removeItem("cotUserphone");
  window.location.replace(urlBotonCotizar);
}
function Cotizador() {
  const [dataResquest, setDataResquest] = useState([])
  const [planes, setDataCPlanes] = useState([]);

  function changeSolicitud(data){   
    localStorage.setItem("ddPhoneNumber", data?.telefono)
    localStorage.setItem("ddIdSolicitud", data?.idSolicitud)
    localStorage.setItem("ddValEmail", data?.email)
    
    if(redirectThanks){
      let newUrlThanks = urlBotonCotizar.trim()+'recomendacion/gracias/';
      window.location.replace(newUrlThanks);
    }else{
      setDataResquest(data)
    }
	}

  const getValuesDefault = async () => {
    const cplanes = await cPlanesService.getCPlanesItems("SHO");
    if(cplanes.length>0){
      const newPlanes = cplanes.filter(p => (p.fi_CATEGORIA === 9))
      setDataCPlanes(newPlanes);
      console.log("cplanes:", newPlanes);
    }
  };

  useEffect(() => {
    getValuesDefault();
    // eslint-disable-next-line
  }, []);

  const [seEstaRegistrando, setSeEstaRegistrando] = useState(false);
  
  const titulo = seEstaRegistrando ? "Por favor espere, estamos registrando su solicitud": "Hemos registrado tu solicitud";
    return (
      <>
      {
        planes.length ?
          dataResquest?.length === 0 ?
            <section className="cCotizadorCards">
              <div className="container">
                <div className="cCotCardsTitle">
                  <h2>{tituloRecomendacion}</h2>
                  <p>{descRecomendacion}</p>
                </div>
                <CardsWrap
                  planes={planes}
                  tituloSolicitarPlan={tituloSolicitarPlan}
                  descSolicitarPlan={descSolicitarPlan}
                  changeSolicitud={changeSolicitud}
                  setSeEstaRegistrando={setSeEstaRegistrando}
                />
                {Parser(String(txtCondiciones))}
                <div className="cCotCardsBtnBack">
                  {txtBotonCotizar && (
                    <button id="cot-volver" className="btn btnBlancoRojo" rel="noopener noreferrer" onClick={() => {   BannerCallBack(urlBotonCotizar); }} target={targetBotonCotizar ? targetBotonCotizar : "_blank"}>
                      {txtBotonCotizar}
                    </button>
                  )}
                </div>
              </div>
            </section>
          :
            <section className="cTYouWrap v2">
              <div className="container">
                <div className="cTYouHeaderOut">
                  <i className="ico-check-circle"></i>
                  <h2 className="h2">{titulo}</h2>
                </div>
                {!seEstaRegistrando && <div className="cTYou">
                  <div className="cTYouList">
                    <dl>
                      <dt>Se ha registrado el número: </dt>
                      <dd>{dataResquest?.telefono}</dd>
                    </dl>
                    <dl>
                      <dt>en la solicitud: </dt>
                      <dd>{dataResquest?.idSolicitud}</dd>
                    </dl>
                    <dl>
                      <dt>con el correo </dt>
                      <dd>{dataResquest?.email}</dd>
                    </dl>
                    <p>En breve uno de nuestros asesores se pondrá en contacto contigo</p>
                    <p>¡Gracias!</p>
                  </div>
                  <div className="cTYouFooter">
                    <button id="cot-finalizar" className="btn btnPrimario" rel="noopener noreferrer" target={"_blank"} onClick={() => {BannerCallBack(urlBotonCotizar);}}>Volver a Inicio</button>
                  </div>
                </div>}
                {
                  seEstaRegistrando && <i className="ico-loader" style={{fontSize: "90px"}}></i>
                }
              </div>
            </section>
        :<div>Loading...</div>
        }
      </>
    );
}

export default Cotizador;
